import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {ApplicationSource} from "../../utils/form/application_form_source";

/** All selectable inquiry topic values for the current lead form variant. */
export const getAmplitudeLeadFormInquiryTopics = (source: ApplicationSource | null): string[] => {
    const {baseOptions, moreOptions} = getCheckboxConfigBySource(source);

    return [...baseOptions, ...moreOptions].map((option) => String(option.labelContent));
};
import {getCheckboxConfigBySource} from "../../constants/lead/lead_modal_checkbox_options";
import {ApplicationSource} from "../../utils/form/application_form_source";

/** All selectable inquiry topic values for the current lead form variant. */
export const getAmplitudeLeadFormInquiryTopics = (source: ApplicationSource | null): string[] => {
    const {baseOptions, moreOptions} = getCheckboxConfigBySource(source);

    return [...baseOptions, ...moreOptions].map((option) => String(option.labelContent));
};
